import { ActionType, IAppAction } from '../../actions/Helpers';

const initialState = {
  user: null,
  authInfo: undefined,
  authLoader: false as boolean,
};
export const auth = (state = initialState, action = {} as IAppAction) => {
  switch (action.type) {
    case ActionType.GET_LOGIN_USER_DETAILS_SUCCESS: {
      const userData = action.payload;
      localStorage.setItem('userId', userData?.userId)
      if (!state.user || userData?.userId) {
        return {
          ...state,
          authInfo: [userData?.userType],
          user: userData
        };
      } else {
        return {
          ...state,
        };
      }
    }
    case ActionType.LOGIN_USER_DETAILS_SHOW_LOADER: {
      return {
        ...state,
        authLoader: true
      };
    }
    case ActionType.LOGIN_USER_DETAILS_HIDE_LOADER: {
      return {
        ...state,
        authLoader: false
      };
    }

    case ActionType.GET_LOGIN_USER_DETAILS_FAILURE: {
      if (state.user) {
        return {
          ...state,
        };
      } else {
        return {
          ...state,

          user: null,
          authInfo: undefined,
        };
      }

    }

    case ActionType.USER_LOGOUT: {
      return {
        ...state,
        user: null,
        authInfo: undefined,
      };
    }
    default:
      return state;
  }
};
